export default function FlightsSearchFormBaseController(
    $scope,
    $state,
    flightsUtils,
    flightsFactory,
    settingsCabinClasses,
    l10nService,
    timeSlots
) {
    'ngInject';

            const _Adult = flightsFactory.params.Travelers.Adult.value;
            const _Infant = flightsFactory.params.Travelers.Infant.value;
            const _Child = flightsFactory.params.Travelers.Child.value;
            const _Class = flightsFactory.params.CabinClass;

            $scope.module = flightsFactory.getModule();
            $scope.isFlights = flightsFactory.isFlights();
            $scope.isTrains = flightsFactory.isTrains();

            $scope.$state = $state;
            $scope.params = flightsFactory.params;
            $scope.options = flightsFactory.options;
            $scope.options.time = flightsFactory.getTimeOptions(timeSlots);

            $scope.options.cabinClasses = prepareCabinClassesOptions(settingsCabinClasses);
            $scope.options.adults = flightsUtils.makeTravellersOptions('Adult', 4, false);
            $scope.options.infants = flightsUtils.makeTravellersOptions('Infant', _Adult, true);
            $scope.options.children = flightsUtils.makeTravellersOptions('Child', 4 - _Adult, true);
            $scope.options.time0 = angular.copy($scope.options.time);
            $scope.options.time1 = angular.copy($scope.options.time);
            $scope.options.time2 = angular.copy($scope.options.time);
            $scope.options.time3 = angular.copy($scope.options.time);

            $scope.frequentFlights = [];

            $scope.getFrequentFlightView = getFrequentFlightView;
            $scope.setSelectedFrequentFlight = setSelectedFrequentFlight;

            /**
             * Initial values
             */
            $scope.params.CabinClass = angular.copy(_Class || $scope.options.cabinClasses[1]);
            $scope.params.Travelers.Adult = angular.copy(_.find($scope.options.adults, {value: _Adult.toString()}));
            $scope.params.Travelers.Infant = angular.copy(_.find($scope.options.infants, {value: _Infant.toString()}));
            $scope.params.Travelers.Child = angular.copy(_.find($scope.options.children, {value: _Child.toString()}));
            $scope.params.TicketSearchSegments[0]._time
                = angular.copy($scope.params.TicketSearchSegments[0]._time) || angular.copy($scope.options.time0[0]);
            $scope.params.TicketSearchSegments[1]._time
                = angular.copy($scope.params.TicketSearchSegments[1]._time) || angular.copy($scope.options.time1[0]);
            $scope.params.TicketSearchSegments[2]._time
                = angular.copy($scope.params.TicketSearchSegments[2]._time) || angular.copy($scope.options.time2[0]);
            $scope.params.TicketSearchSegments[3]._time
                = angular.copy($scope.params.TicketSearchSegments[3]._time) || angular.copy($scope.options.time3[0]);
            delete $scope.params.SearchId;

            /**
             * * Init
             * * $scope.frequentFlights
             */
            getFrequentFlights();

            /**
             * Get frequent flights list
             */
            function getFrequentFlights() {
                flightsFactory.getFrequentFlights().then(function(flights) {
                    $scope.frequentFlights = flights;
                });
            }

            function getFrequentFlightView(flight) {
                const airportName = (flight.AirportName)
                    ? flight.AirportName
                    : getFrequentFlightAllLocationName();

                return _.template('{{cityName}}, {{countryCode}} - {{airportName}} ({{airportCode}})')({
                    cityName: flight.CityName,
                    countryCode: flight.CountryCode,
                    airportName,
                    airportCode: flight.AirportCode,
                });
            }

            function setSelectedFrequentFlight(model, field, viewModel) {
                return function(flight) {
                    viewModel.$setValidity('editable', true);
                    const name = flight.CityName + ', ' + flight.CountryCode;
                    const airport = flight.AirportName ? flight.AirportName : getFrequentFlightAllLocationName();
                    const Code = flight.AirportCode;
                    const DisplayString = name + ' - ' + airport + ' (' + flight.AirportCode + ')';

                    model[field] = {
                        name,
                        airport,
                        Code,
                        DisplayString,
                        IsCity: flight.IsCity,
                        RailStationcode: flight.RailStationCode,
                    };
                };
            }

            function getFrequentFlightAllLocationName() {
                return $scope.isFlights ? l10nService.localize('All Airports')
                    : l10nService.localize('All Train Stations');
            }

          function prepareCabinClassesOptions(cabinClasses) {
            return _.map(cabinClasses, function(cabinClass) {
              return {text: cabinClass.ClassName, value: cabinClass.Id};
            });
          }
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/flightsSearchFormBaseCtrl.js